<template>

    <div class="alert-container" :class="classes">
        <div class="progress"></div>
        <div class="d-flex">
            <v-alert class="mb-0 flex-grow-1" :message="alert.message" :type="alert.type" />
            <div class="close" @click="dismiss">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .alert-container {
        background-color: $color-white;
        box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        margin-bottom: 5px;
        overflow: hidden;
        position: relative;
        &.alert-container-info {
            .close { color: $color-text; }
            .progress { background: $color-text; }
        }
        &.alert-container-danger {
            .close { color: $color-danger; }
            .progress { background: $color-danger; }
        }
        &.alert-container-success {
            .close { color: $color-success; }
            .progress { background: $color-success; }
        }
        .progress {
            animation: progress 5s linear;
            background: $color-text;
            border-radius: 0;
            top: 0;
            height: 2px;
            opacity: 0.5;
            position: absolute;
            width: 0;
            z-index: 1;
        }
        .close {
            align-items: center;
            color: $color-text;
            cursor: pointer;
            display: flex;
            flex-shrink: 0;
            font-size: 16px;
            justify-content: center;
            opacity: 1;
            transition: opacity .3s;
            width: 50px;
            &:hover {
                opacity: 0.5;
            }
        }
    }

    @keyframes progress {
        0%   { width: 0; }
        100% { width: 100%; }
    }

</style>

<script>

export default {

    props: {
        alert: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            timer: null
        }
    },

    created() {
        this.timer = setTimeout(this.dismiss, 5000); // Must match CSS rule.
    },

    computed: {

        classes() {
            let type = this.alert.type;
            return {
                'alert-container-info': type === 'info',
                'alert-container-danger': type === 'danger',
                'alert-container-success': type === 'success',
            };
        },

    },

    methods: {

        dismiss() {
            clearTimeout(this.timer);
            this.$store.commit('removeAlert', this.alert.key);
        },

    },

}

</script>
